import { createContext, useContext } from 'react';
import { useRealtimeNotificationManager, RealtimeNotificationManagerOptions } from '../lib/supabase/notifications/realtimeNotificationService';

interface RealtimeNotificationContextType {
  isConnected: boolean;
}

const RealtimeNotificationContext = createContext<RealtimeNotificationContextType | undefined>(undefined);

interface RealtimeNotificationProviderProps extends RealtimeNotificationManagerOptions {
  children: React.ReactNode;
}

export function RealtimeNotificationProvider({ children, ...options }: RealtimeNotificationProviderProps) {
  const { isConnected } = useRealtimeNotificationManager(options);

  return (
    <RealtimeNotificationContext.Provider value={{ isConnected }}>
      {children}
    </RealtimeNotificationContext.Provider>
  );
}

export function useSupabaseNotificationRealtime() {
  const context = useContext(RealtimeNotificationContext);
  if (context === undefined) {
    throw new Error('useSupabaseNotificationRealtime must be used within a RealtimeNotificationProvider');
  }
  return context;
}